export default {
  pathSimulation: {
    steps: {
      start: { pt: "Início", en: "Start" },
      step: { pt: "Passo", en: "Step" },
      back: { pt: "Anterior", en: "Back" },
      next: { pt: "Próximo", en: "Next" },
      nextStep: { pt: "Próximo Passo", en: "Next Step" },
      stop: { pt: "Encerrar Simulação", en: "Stop Simulation" },
      stopSimple: { pt: "Encerrar", en: "Stop" },
      initialState: { pt: "Estado Inicial", en: "Initial State" },
      finalPartial: { pt: "FINAL (Avançar)", en: "FINAL (Advance)" },
      end: { pt: "Fim da Simulação", en: "End of Simulation" },
      endOfPath: {
        pt: "Simulação concluída. Você está no último passo.",
        en: "Simulation complete. At last step.",
      },
      current: { pt: "Atual", en: "Current" },
    },
    constants: {
      level: { pt: "Nível", en: "Level" },
      branch: { pt: "Ramificação", en: "Branch" },
      currentState: { pt: "Estado Atual", en: "Current State" },
      wordConsumed: { pt: "Palavra Consumida", en: "Word Consumed" },
      activePaths: { pt: "Ramificações Ativas", en: "Active Branches" },
      readSymbol: { pt: "Símbolo Lido", en: "Read Symbol" },
      consumedSymbols: { pt: "Símbolos consumidos", en: "Consumed Symbols" },
      wordLabel: { pt: "Palavra", en: "Word" },
      stack: { pt: "Pilha", en: "Stack" },
      top: { pt: "Topo", en: "Top" },
    },
    status: {
      accepted: { pt: "ACEITA", en: "ACCEPTED" },
      rejected: { pt: "REJEITADA", en: "REJECTED" },
    },
    texts: {
      multiPathTitle: {
        pt: "RAMIFICAÇÕES DISPONÍVEIS",
        en: "AVAILABLE BRANCHES",
      },
      information: {
        pt: "Clique em um item para ver o histórico detalhado da ramificação selecionada.",
        en: "Click an item to see the detailed history of the selected branch.",
      },
    },
    historyDialog: {
      title: {
        en: "Selected Branch History",
        pt: "Histórico da ramificação selecionada",
      },
      close: { pt: "Fechar", en: "Close" },
    },
  },
  errorMessages: {
    manyRulesInSimulation: {
      pt: "Simulação interrompida: Limite de computação excedido (Provável Loop Infinito).",
      en: "Simulation interrupted: Computation limit exceeded (Probable Infinite Loop).",
    },
    computationInterrupted: {
      pt: "A simulação foi interrompida porque o limite de derivações foi atingido. O resultado exibido é parcial.",
      en: "Simulation stopped because the derivation limit was reached. The displayed result is partial.",
    },
    simulationError: {
      pt: "Erro ao simular o autômato. Verifique a palavra ou o servidor.",
      en: "Error simulating the automaton. Check the word or the server.",
    },
  },
};
